import React from 'react';
import PropTypes from 'prop-types';

export default function StepSessionSummary({ assignTopic }) {
  return (
    <div
      className="selected-topic icon-with-text "
    >
      <div className="counting-icon" />
      <div className="text-content">
        {assignTopic.attributes.title}
      </div>
    </div>
  );
}

StepSessionSummary.propTypes = {
  assignTopic: PropTypes.object,
};

StepSessionSummary.defaultProps = {
  assignTopic: null,
};
